const changes = [
  { icon: 'ri-database-2-line', title: 'Новая CRM', desc: 'Необходимо изменить не только программу, но и привычки работы менеджеров: как они вносят данные, ведут сделки и используют систему в ежедневной работе.' },
  { icon: 'ri-flow-chart', title: 'Новые бизнес-процессы', desc: 'Сотрудникам необходимо понимать новую последовательность действий, зоны ответственности и критерии результата.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Новая система мотивации', desc: 'Изменение KPI и правил оплаты напрямую затрагивает интересы людей и может вызвать сильное сопротивление.' },
  { icon: 'ri-organization-chart', title: 'Реструктуризация', desc: 'Меняются роли, зоны ответственности и взаимодействие подразделений — это требует перестройки привычных отношений.' },
  { icon: 'ri-bar-chart-2-line', title: 'Масштабирование', desc: 'Старые способы управления перестают работать при росте компании, и нужны новые процессы и стандарты.' },
  { icon: 'ri-user-star-line', title: 'Новый руководитель', desc: 'Команде необходимо адаптироваться к новым требованиям, стилю управления и ожиданиям.' },
  { icon: 'ri-file-list-3-line', title: 'Новые стандарты', desc: 'Необходимо превратить правила из документа в повседневное поведение и закрепить их в контроле.' },
  { icon: 'ri-cpu-line', title: 'Цифровая трансформация', desc: 'Технологические изменения требуют изменения навыков, привычек и способа работы сотрудников.' },
];

export default function ChangeTypes() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Какие изменения требуют управленческой работы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          С какими изменениями сталкиваются компании — и почему каждое из них нельзя внедрить простым приказом
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {changes.map((c) => (
            <div key={c.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${c.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{c.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}